<div class="errors-visualizer">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h2 mat-dialog-title class="mb-0">
      <u>{{ "errorsVisualizerDialog.title" | translate }}</u>
    </h2>
  </div>
  <div mat-dialog-content>
    <!-- Content -->
    <table mat-table [dataSource]="AuditLogErrorsData" class="width-100">
      <ng-container matColumnDef="erroredTime" width="200px">
        <th mat-header-cell *matHeaderCellDef>Errored Time</th>
        <td mat-cell *matCellDef="let row">
          <div matTooltip="{{
                      timeZoneSelected != 'UTC' ?
                      '(' + (row.erroredTime | date : 'zzzz') + ') ' + timeZoneSelected
                      : timeZoneSelected
                      }}">
            {{ row.erroredTime + 'Z' | date : "yyyy-MM-dd HH:mm:ss" : timeZoneSelected }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="errorMessage">
        <th mat-header-cell *matHeaderCellDef>Error Message</th>
        <td mat-cell *matCellDef="let row">
          {{ row.errorMessage }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>
      {{ "errorsVisualizerDialog.close" | translate }}
    </button>
  </div>
</div>
